<template lang="pug">
.wechat-mp-card-container
  .title 7天3次助力车骑行卡
  .card
    .card-title 助力车
    span.price
      span.amount 3
      span.unit 次
    .subtitle 限哈啰App使用，7天3次卡
  .btn.btn-one.flex-mid(@click="openModal")
    .tip 下载哈啰App优惠骑行
      .toast.flex-mid 新人本单骑行免费
    .time(v-if="countdown.length")
      span(v-for="(item, index) in countdown" :key="index")
        span {{item}}
        span(v-if="!(index === countdown.length - 1)") :
      span &nbsp;后失效
  .btn.btn-two.flex-mid(@click="goToCycle") *看广告继续骑行
  guide-modal(:show.sync="modal")
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import GalileoAb from '@hb/ab-sdk';
import config from '@/const/config';
import { configWechatSDK } from '@/utils/wechat';
import { env } from '@hb/NBridge/lib/h5';
import Clipboard from 'clipboard';
import pkg from '../../../package.json';
import { getTokenAndLocation, isPreRender } from '../../utils';
import { UBTUtils } from '../../utils/ubt';
import GuideModal from './components/guide-modal.vue';
import { formatDuration } from '../welfare/utils';
import { ENTER_TYPE } from './const';

export default {
  components: {
    GuideModal,
  },
  data() {
    return {
      modal: false,
      countdownSecond: null,
      countdown: [],
      isAdvCity: 1,
      enterType: ENTER_TYPE(),
      curEnterType: null,
      clipboard: null,
    };
  },
  created() {
    // if (isPreRender()) {
    //   document.dispatchEvent(new Event('render-event'));
    //   // eslint-disable-next-line no-useless-return
    //   return;
    // }
    const { command, enterType } = this.$route.query;
    this.curEnterType = Number(enterType);
    if (command && Clipboard) {
      this.clipboard = new Clipboard('.btn', {
        text() {
          return command;
        },
      });
    }
    this.config();
    this.initGalileoAb();
  },
  mounted() {
    this.initCountdown();
  },
  destroyed() {
    if (this.clipboard) {
      this.clipboard.destroy();
    }
  },
  methods: {
    config() {
      if (env.isWechatMini) {
        configWechatSDK();
      }
    },
    async initGalileoAb() {
      const { cityCode } = await getTokenAndLocation();
      const galileoAb = new GalileoAb(
        {
          env: config.env,
          version: pkg.version,
          appName: 'AppHellobikeWXSS',
          systemCode: 64,
        },
        UBT, // 初始化后的UBT对象
      );
      const { city_zlc: zlc } = await galileoAb.getAbSingleTestResult({
        experimentId: '202204021701091442', // 实验id
        cityCode, // 非必填
        customVariable: {
          city: cityCode,
        },
        defaultVersionId: '202204021701098617', // 兜底版本
      })
        .then((res) => res.versionArgs || { city_zlc: 1 })
        .catch(() => ({ city_zlc: 1 }));
      this.isAdvCity = zlc;
    },
    initCountdown() {
      this.countdownSecond = 10 * 60; // 10分钟倒计时
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    updateCountdown() {
      if (this.countdownSecond < 0) {
        clearInterval(this.timer);
        this.initCountdown();
        return;
      }
      const { hours, minutes, seconds } = formatDuration(
        this.countdownSecond * 1000,
      );
      this.countdownSecond -= 1;
      this.countdown = [hours, minutes, seconds];
    },
    openModal() {
      if (this.curEnterType === this.enterType.wechat) {
        UBTUtils.clickButton({
          pageId: 'wxkl_zlc_wxsys',
          buttonName: 'wxkl_zlc_xslq1',
          categoryId: 'platform',
          businessInfo: {},
        });
      }
      if (this.curEnterType === this.enterType.platform) {
        UBTUtils.clickButton({
          pageId: 'wxkl_zlc_ptsys',
          buttonName: 'xslq_ptsys',
          categoryId: 'platform',
          businessInfo: {},
        });
      }
      this.modal = true;
    },
    goToCycle() {
      if (window.wx) {
        if (this.curEnterType === this.enterType.wechat) {
          UBTUtils.clickButton({
            pageId: 'wxkl_zlc_wxsys',
            buttonName: 'wxkl_zlc_goon1',
            categoryId: 'platform',
            businessInfo: {},
          });
        }
        if (this.curEnterType === this.enterType.platform) {
          UBTUtils.clickButton({
            pageId: 'wxkl_zlc_ptsys',
            buttonName: 'wxkl_zlc_gobike',
            categoryId: 'platform',
            businessInfo: {},
          });
        }
        const url = Number(this.isAdvCity)
          ? '/pages/AppHelloOhoWeChat/src/pages/index/index'
          : '/pages/ad/index';
        window.wx.miniProgram.navigateTo({ url });
      }
    },
  },
};
</script>

<style lang="less">
.wechat-mp-card-container {
  height: 100vh;
  background: url('https://m.hellobike.com/resource/helloyun/15979/_2aAk2lFFr.png') no-repeat;
  background-size: 100%;
  padding-top: 0.54rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .title {
    font-size: 0.36rem;
    font-weight: bold;
    color: #0366ff;
    line-height: 0.5rem;
    text-align: center;
    margin-bottom: 0.22rem;
  }

  .card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .card-title {
      font-size: 0.14rem;
      font-weight: 500;
      color: #eb742e;
      line-height: 0.2rem;
    }

    .price {
      position: relative;
      color: #eb742e;

      .amount {
        font-size: 0.48rem;
        font-weight: 600;
        line-height: 0.74rem;
      }

      .unit {
        position: relative;
        top: -0.02rem;
        font-size: 0.22rem;
        font-weight: bold;
        line-height: 0.3rem;
      }
    }

    .subtitle {
      position: relative;
      top: -0.08rem;
      font-size: 0.13rem;
      color: #5a6066;
      line-height: 0.18rem;
    }
  }

  .btn {
    width: 3.43rem;
    height: 0.48rem;
  }

  .btn-one {
    position: relative;
    margin-top: 2rem;
    background: url('https://m.hellobike.com/resource/helloyun/15979/SfW9peFIR8.png') no-repeat;
    background-size: 100%;
    font-size: 0.18rem;
    font-weight: 500;
    color: #fff;
    line-height: 0.25rem;
    flex-direction: column;

    .tip {
      position: relative;
      font-weight: bold;

      .toast {
        position: absolute;
        width: 1.1rem;
        height: 0.2rem;
        background: #f72626;
        border-radius: 0.12rem 0.12rem 0.12rem 0;
        border: 0.01rem solid #fff;
        font-size: 0.12rem;
        font-weight: 500;
        color: #fff;
        line-height: 0.12rem;
        top: -80%;
        left: 74%;
      }
    }

    .time {
      position: relative;
      font-size: 0.11rem;
      line-height: 0.16rem;
    }
  }

  .btn-two {
    margin-top: 0.12rem;
    font-size: 0.18rem;
    color: #242729;
    line-height: 0.25rem;
    border-radius: 0.08rem;
    border: 0.01rem solid #d3dae0;
  }
}
</style>
